import { connect } from 'react-redux';

import {
  ADD_IMAGE_TO_PLACE_PUBLIC_IMAGES,
  DELETE_IMAGE_FROM_PLACE_PUBLIC_IMAGES,
  DELETE_PLACE_VIDEO,
  GET_PLACE_DETAIL,
  POST_PLACE_PREVIEW_IMAGE,
  UPDATE_PLACE_VIDEO,
} from 'store/place/actionTypes';
import { UPLOAD_MULTIPLE_MEDIA, UPLOAD_VIDEO } from 'store/media/actionTypes';

import SectionPlacePictureList from './SectionPlacePictureList';

const mapStateToProps = (state) => ({
  placeDetail: state.Place.placeDetail,

  isLoadingAddImageToPublicImages: state.Place.isLoadingAddImageToPublicImages,
  isLoadingUpdatePlaceVideo: state.Place.isLoadingUpdatePlaceVideo,
  isLoadingDeletePlaceVideo: state.Place.isLoadingDeletePlaceVideo,
  isLoadingDeleteImageFromPublicImages: state.Place.isLoadingDeleteImageFromPublicImages,
  isLoadingGetPlaceDetail: state.Place.isLoadingGetPlaceDetail,
  isLoadingPostPlacePreviewImage: state.Place.isLoadingPostPlacePreviewImage,
  isLoadingUploadMultipleMedia: state.Media.isLoadingUploadMultipleMedia,
  isLoadingUploadVideo: state.Media.loadingUploadVideo,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetPlaceDetail: (payload) => dispatch({
    type: GET_PLACE_DETAIL,
    payload,
  }),

  actionPostPlacePreviewImage: (payload) => dispatch({
    type: POST_PLACE_PREVIEW_IMAGE,
    payload,
  }),

  actionUploadMultiMedia: (payload) => dispatch({
    type: UPLOAD_MULTIPLE_MEDIA,
    payload,
  }),

  actionUploadVideo: (payload) => dispatch({
    type: UPLOAD_VIDEO,
    payload,
  }),

  actionAddImageToPublicImages: (payload) => dispatch({
    type: ADD_IMAGE_TO_PLACE_PUBLIC_IMAGES,
    payload,
  }),

  actionUpdatePlaceVideo: (payload) => dispatch({
    type: UPDATE_PLACE_VIDEO,
    payload,
  }),

  actionDeletePlaceVideo: (payload) => dispatch({
    type: DELETE_PLACE_VIDEO,
    payload,
  }),

  actionDeleteFromPublicImages: (payload) => dispatch({
    type: DELETE_IMAGE_FROM_PLACE_PUBLIC_IMAGES,
    payload,
  }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SectionPlacePictureList);
